import type {
  ChannelId,
  ProposalId,
  TenantId,
} from '../core/contracts/channel-agent.js';
import type { KanbanProposal } from '../core/contracts/proposals.js';

export class ProposalService {
  private proposals = new Map<string, KanbanProposal>();

  saveProposal(proposal: KanbanProposal): KanbanProposal {
    this.proposals.set(proposal.proposalId, { ...proposal });
    return proposal;
  }

  getProposal(proposalId: ProposalId): KanbanProposal | undefined {
    const p = this.proposals.get(proposalId);
    return p ? { ...p } : undefined;
  }

  listPendingProposals(channelId?: ChannelId, tenantId?: TenantId): KanbanProposal[] {
    const now = Date.now();
    const result: KanbanProposal[] = [];
    for (const p of this.proposals.values()) {
      if (p.status === 'pending' && now <= p.expiresAt) {
        if (!channelId || p.channelId === channelId) {
          if (!tenantId || p.tenantId === tenantId) {
            result.push({ ...p });
          }
        }
      }
    }
    return result;
  }

  updateProposalStatus(proposalId: ProposalId, status: KanbanProposal['status']): KanbanProposal {
    const p = this.proposals.get(proposalId);
    if (!p) throw new Error(`Proposal ${proposalId} not found`);

    p.status = status;
    this.proposals.set(proposalId, p);
    return { ...p };
  }
}
